import { userConst } from '../consts';

const initialState = { initing: true, logined:  localStorage.getItem('logined') === 'true'};

export function auth(state = initialState, action) {
    switch (action.type) {
        case userConst.LOGIN_REQUEST:
            return {
                logining: true
            };
        case userConst.LOGIN_SUCCESS:
            localStorage.setItem('logined', true);
            return {
                logined: true,
                changing: false,
                user: action.user
            };
        case userConst.LOGIN_FAILURE:
            return {
                errors: action.errors
            };
        case userConst.CHANGE_REQUEST:
            return {
                ...state,
                changing: true,
                errors: undefined
            };
        case userConst.CHANGE_SUCCESS:
            return {
                ...state,
                user: action.user,
                changing: false
            };
        case userConst.CHANGE_FAILURE:
            return {
                ...state,
                errors: action.errors,
                changing: false
            };
        case userConst.LOGOUT:
            localStorage.removeItem('logined');
            return {};
        case userConst.CLEAR_ERRORS:
            return {
                ...state,
                errors: undefined
            };
        default:
            return state;
    }
}
